import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'UserAdmin',
    loadChildren: () => import('../generated/routes/UserAdmin.module').then((m) => m.UserAdminModule)
  },
  {
    path: 'UserClient',
    loadChildren: () => import('../generated/routes/UserClient.module').then((m) => m.UserClientModule)
  },
  {
    path: 'UserClientGroup',
    loadChildren: () => import('../generated/routes/UserClientGroup.module').then((m) => m.UserClientGroupModule)
  },
  {
    path: 'ImportingFile',
    loadChildren: () => import('../generated/routes/ImportingFile.module').then((m) => m.ImportingFileModule)
  },

  {
    path: 'ConvertingFile',
    loadChildren: () => import('../generated/routes/ConvertingFile.module').then((m) => m.ConvertingFileModule)
  },
  {
    path: 'AvailableAiModels',
    loadChildren: () => import('../generated/routes/AvailableAiModels.module').then((m) => m.AvailableAiModelsModule)
  },
  {
    path: 'ExternalTagMapper',
    loadChildren: () => import('../generated/routes/ExternalTagMapper.module').then((m) => m.ExternalTagMapperModule)
  },
  {
    path: 'Tag',
    loadChildren: () => import('../generated/routes/Tag.module').then((m) => m.TagModule)
  },
  {
    path: 'TagType',
    loadChildren: () => import('../generated/routes/TagType.module').then((m) => m.TagTypeModule)
  },
  {
    path: 'Assistant',
    loadChildren: () => import('../generated/routes/Assistant.module').then((m) => m.AssistantModule)
  },
  {
    path: 'CopywriterStyleRecord',
    loadChildren: () => import('../generated/routes/CopywriterStyleRecord.module').then((m) => m.CopywriterStyleRecordModule)
  },
  {
    path: 'LlmAction',
    loadChildren: () => import('../generated/routes/LlmAction.module').then((m) => m.LlmActionModule)
  },
  {
    path: 'DocumentalisteSearch',
    loadChildren: () => import('../generated/routes/DocumentalisteSearch.module').then((m) => m.DocumentalisteSearchModule)
  },
  {
    path: 'CreateDocumentWord',
    loadChildren: () => import('../generated/routes/CreateDocumentWord.module').then((m) => m.CreateDocumentWordModule)
  },
  {
    path: 'CreateDocumentExcel',
    loadChildren: () => import('../generated/routes/CreateDocumentExcel.module').then((m) => m.CreateDocumentExcelModule)
  },
  {
    path: 'Copywriter',
    loadChildren: () => import('../generated/routes/Copywriter.module').then((m) => m.CopywriterModule)
  },
  {
    path: 'Deepl',
    loadChildren: () => import('../generated/routes/Deepl.module').then((m) => m.DeeplModule)
  },
  {
    path: 'DocumentAnalystDiscovery',
    loadChildren: () => import('../generated/routes/DocumentAnalystDiscovery.module').then((m) => m.DocumentAnalystDiscoveryModule)
  },
  {
    path: 'DocumentDataAnalyst',
    loadChildren: () => import('../generated/routes/DocumentDataAnalyst.module').then((m) => m.DocumentDataAnalystModule)
  },
  {
    path: 'adaptivLog',
    loadChildren: () => import('../generated/routes/adaptivLog.module').then((m) => m.adaptivLogModule)
  },
  {
    path: 'ExternalTagTypeMapper',
    loadChildren: () => import('../generated/routes/ExternalTagTypeMapper.module').then((m) => m.ExternalTagTypeMapperModule)
  },
  {
    path: 'ExternalRoleMapper',
    loadChildren: () => import('../generated/routes/ExternalRoleMapper.module').then((m) => m.ExternalRoleMapperModule)
  },
  {
    path: 'Graph',
    loadChildren: () => import('../generated/routes/Graph.module').then((m) => m.GraphModule)
  },
  {
    path: 'OpenAiChat',
    loadChildren: () => import('../generated/routes/OpenAiChat.module').then((m) => m.OpenAiChatModule)
  },
  {
    path: 'ChatUpload',
    loadChildren: () => import('../generated/routes/ChatUpload.module').then((m) => m.ChatUploadModule)
  },
  {
    path: 'ImageToVideo',
    loadChildren: () => import('../generated/routes/ImageToVideo.module').then((m) => m.ImageToVideoModule)
  },
  /* {
    path: 'FlowLLMAction',
    loadChildren: () => import('../generated/routes/FlowLLMAction.module').then((m) => m.FlowLLMActionModule)
  },*/

  {
    path: 'ImageControl',
    loadChildren: () => import('../generated/routes/ImageControl.module').then((m) => m.ImageControlModule)
  },

  {
    path: 'Creative',
    loadChildren: () => import('../generated/routes/Creative.module').then((m) => m.CreativeModule)
  },
  {
    path: 'AudioToChunks',
    loadChildren: () => import('../generated/routes/AudioToChunks.module').then((m) => m.AudioToChunksModule)
  },
  {
    path: 'VideoToChunks',
    loadChildren: () => import('../generated/routes/VideoToChunks.module').then((m) => m.VideoToChunksModule)
  },
  {
    path: 'AdaptivIcon',
    loadChildren: () => import('../generated/routes/AdaptivIcon.module').then((m) => m.AdaptivIconModule)
  },
  {
    path: 'Flow',
    loadChildren: () => import('../generated/routes/Flow.module').then((m) => m.FlowModule)
  },
  {
    path: 'UserRole',
    loadChildren: () => import('../generated/routes/UserRole.module').then((m) => m.UserRoleModule)
  },
  {
    path: 'Template',
    loadChildren: () => import('../generated/routes/Template.module').then((m) => m.TemplateModule)
  },
  {
    path: 'Researcher',
    loadChildren: () => import('../generated/routes/Researcher.module').then((m) => m.ResearcherModule)
  },
  {
    path: 'TranslatorStyle',
    loadChildren: () => import('../generated/routes/TranslatorStyle.module').then((m) => m.TranslatorStyleModule)
  },
  {
    path: 'DataPrivacy',
    loadChildren: () => import('../generated/routes/DataPrivacy.module').then((m) => m.DataPrivacyModule)
  },
  {
    path: 'Translator',
    loadChildren: () => import('../generated/routes/Translator.module').then((m) => m.TranslatorModule)
  },
  {
    path: 'SearchAndReplace',
    loadChildren: () => import('../generated/routes/SearchAndReplace.module').then((m) => m.SearchAndReplaceModule)
  },

  {
    path: 'BackgroundChange',
    loadChildren: () => import('../generated/routes/BackgroundChange.module').then((m) => m.BackgroundChangeModule)
  },
  {
    path: 'Coach',
    loadChildren: () => import('../generated/routes/Coach.module').then((m) => m.CoachModule)
  },
  {
    path: 'CreatePresentation',
    loadChildren: () => import('../generated/routes/CreatePresentation.module').then((m) => m.CreatePresentationModule)
  },

  {
    path: 'DocumentChunkSearch',
    loadChildren: () => import('../generated/routes/DocumentChunkSearch.module').then((m) => m.DocumentChunkSearchModule)
  },
  {
    path: 'DocumentDataDiscovery',
    loadChildren: () => import('../generated/routes/DocumentDataDiscovery.module').then((m) => m.DocumentDataDiscoveryModule)
  },
  { path: 'ExcelToChunks', loadChildren: () => import('../generated/routes/ExcelToChunks.module').then((m) => m.ExcelToChunksModule) },
  {
    path: 'FileImageDataToChunks',
    loadChildren: () => import('../generated/routes/FileImageDataToChunks.module').then((m) => m.FileImageDataToChunksModule)
  },
  {
    path: 'LangChainFileToChunck',
    loadChildren: () => import('../generated/routes/LangChainFileToChunck.module').then((m) => m.LangChainFileToChunckModule)
  },
  { path: 'Outpaint', loadChildren: () => import('../generated/routes/Outpaint.module').then((m) => m.OutpaintModule) },
  { path: 'PDFToChunks', loadChildren: () => import('../generated/routes/PDFToChunks.module').then((m) => m.PDFToChunksModule) },
  { path: 'PdfToImages', loadChildren: () => import('../generated/routes/PdfToImages.module').then((m) => m.PdfToImagesModule) },
  {
    path: 'VisionImageDescription',
    loadChildren: () => import('../generated/routes/VisionImageDescription.module').then((m) => m.VisionImageDescriptionModule)
  },

  {
    path: 'VisionSlideType',
    loadChildren: () => import('../generated/routes/VisionSlideType.module').then((m) => m.VisionSlideTypeModule)
  },
  {
    path: 'ChatLlmAction',
    loadChildren: () => import('../generated/routes/ChatLlmAction.module').then((m) => m.ChatLlmActionModule)
  },
  {
    path: 'Flows',
    loadChildren: () => import('../generated/routes/Flow.module').then((m) => m.FlowModule)
  },
  {
    path: 'ServiceDeployed',
    loadChildren: () => import('../generated/routes/ServiceDeployed.module').then((m) => m.ServiceDeployedModule)
  },
  {
    path: 'SharedLibraryApiKey',
    loadChildren: () => import('../generated/routes/SharedLibraryApiKey.module').then((m) => m.SharedLibraryApiKeyModule)
  },
  {
    path: 'SharedLibrarySubscription',
    loadChildren: () => import('../generated/routes/SharedLibrarySubscription.module').then((m) => m.SharedLibrarySubscriptionModule)
  },
  {
    path: 'protoschema',
    loadChildren: () => import('../generated/routes/protoschema.module').then((m) => m.protoschemaModule)
  }
];

@NgModule({
  declarations: [],
  imports: [CommonModule, RouterModule.forChild(routes)],
  exports: []
})
export class DataModule {}
